<script>
import { ref, computed } from 'vue';

import { ArrowDownCircleIcon, ChevronDownIcon } from '@thehotelsnetwork/icons/vue/linear';

import { track } from '@/utils/analytics';
import handleDownloadReport from '@/utils/handleDownloadReport';
import bdLogger from '@/utils/bdLogger';

import OptionsList from '@/components/OptionsList/OptionsList.vue';

export default {
  name: 'DownloadSelect',
  components: {
    ArrowDownCircleIcon,
    ChevronDownIcon,
    OptionsList,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const generatingReport = ref(false);
    const isDisabled = computed(() => props.disabled || generatingReport.value);

    const handleTrackDownload = async (item) => {
      track(`download - ${item.tag}`);

      generatingReport.value = true;

      try {
        await handleDownloadReport({ format: item.tag });
      } catch (err) {
        bdLogger.warn(err);
      }

      generatingReport.value = false;
    };

    return {
      handleTrackDownload,
      isDisabled,
    };
  },
};
</script>

<template>
  <LpDropdown
    data-testid="downloadBtn"
    :disabled="isDisabled"
    x-position="right"
  >
    <template #btn>
      <LpButton
        mode="transparent"
        color="white"
        size="small"
      >
        <div class="flex items-center gap-2">
          <ArrowDownCircleIcon class="w-5 h-5" />
          <span class="text-sm">{{ $t('Download') }}</span>
          <ChevronDownIcon class="w-3 h-3" />
        </div>
      </LpButton>
    </template>
    <template #menu="{ closeMenu }">
      <OptionsList
        :options="options"
        class="min-w-dropdown-sm"
        @click="(item) => {
          handleTrackDownload(item);
          closeMenu();
        }"
      />
    </template>
  </LpDropdown>
</template>
